import TableDataRow from "./TableDataRow";

export default TableDataRow;
